import logoMobile from "./assets/corail-marque.svg";

export function Footer() {
  return (
    <footer className="border-t bg-card">
      <div className="container mx-auto flex items-center justify-center h-12 px-4">
        <a
          href="/"
          className="flex items-center gap-2 opacity-50 hover:opacity-90 transition-opacity"
        >
          <img src={logoMobile} alt="Corail RH" className="h-5 w-auto" />
          <span className="text-xs font-medium text-muted-foreground">
            Corail RH
          </span>
        </a>
      </div>
    </footer>
  );
}
